import { cn } from '@/lib/utils'

export function RiskBadge({ level }: { level: string | null | undefined }) {
  if (!level) return null

  const normalized = level.toLowerCase().trim()
  
  let fillCount = 5
  let colorClass = 'text-brand'
  let labelText = 'Medio'

  if (normalized.includes('muy bajo')) {
    fillCount = 8
    colorClass = 'text-brand'
    labelText = 'Muy Bajo'
  } else if (normalized.includes('bajo')) {
    fillCount = 7
    colorClass = 'text-brand'
    labelText = 'Bajo'
  } else if (normalized.includes('muy alto')) {
    fillCount = 1
    colorClass = 'text-danger'
    labelText = 'Muy Alto'
  } else if (normalized.includes('alto')) {
    fillCount = 3
    colorClass = 'text-warn'
    labelText = 'Alto'
  }

  const blocks = Array.from({ length: 10 }, (_, i) => {
    const isFilled = i < fillCount
    return (
      <span
        key={i}
        className={cn(
          'text-[10px] leading-none tracking-tight font-black font-mono select-none mr-[1px]',
          isFilled ? colorClass : 'text-text-dim/20'
        )}
      >
        ■
      </span>
    )
  })

  return (
    <div className="flex flex-col items-start gap-1">
      <span className="text-[9px] uppercase font-bold tracking-wider text-text-dim">
        Riesgo
      </span>
      <div className="flex items-center gap-2">
        <div className="flex leading-none">{blocks}</div>
        <span className={cn('text-[10px] font-bold uppercase tracking-wider', colorClass)}>
          {labelText}
        </span>
      </div>
    </div>
  )
}
